import { t } from "i18next";

export const CUSTOM_INSTRUCTIONS_MAX_LENGTH = 500;

export const CREDENTIAL_DEFAULT_INSTRUCTIONS = () =>
  t(
    "Provide details of your credentials, such as licences, certifications, registrations, or professional designations."
  );

export const EMPLOYMENT_DEFAULT_INSTRUCTIONS = () =>
  t(
    "In order to perform an accurate employment check, we ask for employment history. It helps us verify your employment and reduce any possible risk of fraud. Provide details about a current or past employer(s)."
  );

export const REFERENCE_DEFAULT_INSTRUCTIONS = () =>
  t(
    "To complete the reference check, please provide contact details for your references. Certn may contact these individuals to verify your character or work history."
  );

export const EDUCATION_DEFAULT_INSTRUCTIONS = (
  _verificationType?: string | null
) =>
  t(
    "Provide details about your educational background, including any completed or in-progress studies."
  );
